import * as yup from 'yup';

export const AddRetailItemSchema = yup.object().shape({
  PurchaseCategory: yup
    .string()
    .required('Please select at-least one category'),
  item: yup.string().required('Please select at-least one item'),
  tipRecipent: yup.number().required().positive().integer(),
  quantity: yup.number(),
  discountDollars: yup
    .number()
    .typeError('you must specify a number')
    .min(0, 'Min value 0'),
  discountPercentage: yup
    .number()
    .typeError('you must specify a number')
    .min(0, 'Min value 0')
    .max(100, 'Max value 100 can be entered!')
});
